import { render, staticRenderFns } from "./dizionario.vue?vue&type=template&id=f588d920&"
import script from "./dizionario.vue?vue&type=script&lang=ts&"
export * from "./dizionario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports